import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  FromFYObj: null,
  ToFYObj: null,
};

const closeBookFYDetailsSlice = createSlice({
  name: "FYDetails",
  initialState: INITIAL_STATE,
  reducers: {
    setCloseBookFY: (state, action) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    setCloseBookFYReset: () => ({ ...INITIAL_STATE }),
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { setCloseBookFY, setCloseBookFYReset } =
  closeBookFYDetailsSlice.actions;
export default closeBookFYDetailsSlice.reducer;
